<template>
    <div class="container ub ub-ver">

      <div class="gzw ub ub-ac ub-pc">
        <img src="../../assets/img/new2024/gzw.jpg" alt="">
      </div>

      <div class="tip">
        <span>温馨提示，由于你是从分享链接进入的，可能会导致某些权限没有打开，为了方便后续找到小火柴的入口，请从正门进入，关注微信公众号：{{name}}</span>
      </div>

      <div class="qrCode-block ub ub-ver ub-pc">
        <div>
          <img class="tag-blink-left" src="../../assets/img/new2024/bg-all.png">
          <span class="identify-tip">长按识别二维码</span>
          <img class="tag-blink-right" src="../../assets/img/new2024/bg-all.png">
        </div>
        <img class="under" style="transform: rotate(90deg); margin-top:0.5rem;margin-right:1px;" src="../../assets/img/箭头2.png">
        <img class="under" style="margin-top:-0.5rem" src="../../assets/img/箭头-下.png">
        <div class="qr-code ub ub-ac ub-pc">
          <img :src="qrcode">
        </div>
      </div>

      <div class="weixin-search ub">
          <div class="qr ub ub-ac ub-pc">
            <img :src="qrcode">
          </div>
          <div class="gzh-block">
            <div class="tit ub ub-pc">
              <img src="../../assets/img/微信.png">
              <span>微信搜一搜</span>
            </div>
            <div class="search ub ub-pc">
              <img src="../../assets/img/new2024/search.png">
              <span>{{name}}</span>
            </div>
          </div>
        </div>

    </div>
  </template>
  
  <script>
  import * as tool from "../../api/common";
  import { mapMutations, mapActions } from 'vuex';
  export default {
    data() {
      return {
        qrcode: "",
        name: ""
      };
    },
    mounted() {
        this.init_page();
        this.$parent.hidden_remind_bindTel();
        this.$loading.close();
        var self = this;
        setTimeout(()=>{
          self.$loading.close();
        },1000)
    },
    methods: {
      ...mapMutations(['get', 'post']), //引入方法
      init_page() {
        var self = this;
        self.get({
          url: '/App/GetSysDic/?uid=123',
          success: function (data) {
            if(data){
              self.qrcode = data.wx_gzh2_qrcode;
              self.name = data.wx_gzh2_name;
            }
          }
        });
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .container {
    min-height: 100vh;
    background: linear-gradient(to bottom,#FF5C01 40%, #fff);

    .gzw {
      img {
       width: 100%; 
       height: 100%;
      }
    }

    .tip {
      margin: 0 1rem;
      margin-top: 1rem;
      padding: 1rem 0.8rem;
      background-color: #fff;
      border-radius: 0.5rem;
      span {
        font-size: 0.9rem;
        color: #333;
      }
    }

    .qrCode-block {
      padding: 1rem;
      margin: 0 1rem;
      margin-top: 1rem;
      background-color: #fff;
      border-radius: 1rem;

      .tag-blink-left {
          width: 0.8rem;
          height: 0.8rem;
          margin-right: 0.5rem;
      }
      .identify-tip {
        font-size: 1rem;
        font-weight: bold;
        color: #333;
      }
      .tag-blink-right {
          width: 0.8rem;
          height: 0.8rem;
          margin-left: 0.3rem;
        }
      .under {
        width: 1rem;
        height: 1rem;
      }
      .qr-code {
        border: 1px solid rgba(186, 97, 255, 1);
      }
    }

    .weixin-search {
      margin: 1rem;
      padding: 1rem 0.8rem;
      background-color: #07C261;
      border-radius: 1rem;
      .qr {
        width: 6rem;
        height: 6rem;
        background-color: #fff;
        border-radius: 0.5rem;
        img {
          width: 5rem;
          height: 5rem;
        }
      }
      .gzh-block {
        margin-left: 1rem;
        flex: 1;
        .tit {
          img {
            width: 3rem;
            height: 3rem;
          }
          span {
            margin-left: 0.5rem;
            font-size: 1.5rem;
            font-weight: 500;
            color: #fff;
          }
        }
        .search {
          padding: 0 0.8rem;
          width: 10rem;
          height: 2rem;
          background-color: #fff;
          border-radius: 0.3rem;
          img {
            width: 1.5rem;
            height: 1.5rem;
          }
          span {
            margin-left: 0.5rem;
            font-size: 1.1rem;
            font-weight: 600;
            color: #333;
          }
        }
      }
    }

  }
  </style>